import React from 'react';
import UIComponent from 'ui-components/ui-component';
import EventCenter from 'global-libs/old-event/event-center';
import Header from './header/header';
import AppMenu from './menu/menu';
import ResContainer from './res-container/res-container';
import ModalWindow from 'ui-components/modal-window/modal-window';
import H5ToolPlayer from 'ui-components/h5-tool-player/h5-tool-player';
import VideoPlayer from 'ui-components/video-player/video-player';
import CoolFetch from 'global-libs/fetch/cool-fetch';
import Config from 'global-libs/config/config';
import './home-page-style.scss';
export default class HomePage extends UIComponent {
    awake() {
        super.awake();
        EventCenter.addEventListener("show-res", (e) => {
            let player = null;
            if (e.res_type == 1) {
                player = <H5ToolPlayer key={e.resName} title={e.resName} src={e.url} onQuit={() => {
                    this.setState({
                        showRes: false,
                        player: null
                    });
                }} />
            } else if (e.res_type == 2) {
                player = <VideoPlayer key={e.urls} srcs={e.urls} autoPlay={true}
                    onQuit={() => {
                        this.setState({
                            showRes: false,
                            player: null
                        });
                    }}
                />
            }
            this.setState({
                showRes: true,
                player: player
            });
        })
    }
    get className() {
        return "home-page";
    }
    get isRegisterEvent() {
        return false;
    }
    initState() {
        let state = super.initState();
        state.player = null;
        state.showRes = false;
        return state;
    }
    getChildren() {
        return [
            <Header key={'header'} />,
            <div key={'a1'} style={{ width: "100%", height: "1px", backgroundColor: "#cdcdcd" }} />,
            <AppMenu key={'appmenu'} />,
            <div key={'b1'} style={{ width: "100%", height: "2px", backgroundColor: "#3498db" }} />,
            <ResContainer key={'ResContainer'} />,
            <ModalWindow key={'ModalWindow'} isShow={this.state.showRes}>
                {this.state.player}
            </ModalWindow>
        ];
    }
}
